var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "v-layout",
        { staticClass: "login", attrs: { row: "", wrap: "", just: "" } },
        [
          _c(
            "v-flex",
            {
              staticClass: "login__left",
              attrs: { xs12: "", md6: "", lg6: "" }
            },
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    "align-center": "",
                    "justify-center": "",
                    row: "",
                    "fill-height": ""
                  }
                },
                [
                  _c("div", { staticClass: "login__left--separator" }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "login__left--background",
                    attrs: {
                      src: require("../../assets/background/driveim_bg.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div")
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "login__right text-xs-center",
              attrs: { xs12: "", md6: "", lg6: "" }
            },
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    "align-center": "",
                    "justify-center": "",
                    column: "",
                    "fill-height": ""
                  }
                },
                [
                  _c("img", {
                    staticClass: "login__right--logo",
                    staticStyle: { width: "30% !important" },
                    attrs: {
                      src:
                        "https://res.cloudinary.com/driveim/image/upload/v1686661102/logo-login_wn4oad.jpg",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("router-view")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            column: "",
            "justify-center": "",
            row: "",
            "fill-height": ""
          }
        },
        [
          _c("v-progress-circular", {
            attrs: { width: 3, size: 70, color: "secondary", indeterminate: "" }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e037723", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e037723","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/authorization/template.html
// module id = null
// module chunks = 